import React, { useContext } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion';
import dayjs from 'dayjs';
import { isSSR } from '@front10/utils';
import Disclaimer from './../../../others/Disclaimer';

import Text from '../../../elements/Text';
// import Header from '../../../elements/Header';
import Link from '../../../elements/Link';
import Box from '../../../elements/Box';
import Icon from '../../../elements/Icon';

const RequirementsAccordion = (props) => {
  const {
    // accordionTitle = {},
    categoryTitle = {},
    categoryLabel = {},
    categoryText = {},
    accordionContentTitle = {},
    categoryTitleContainerSetting = {},
    detailsAndExemptionsContainerSettings = {},
    accordionUI = {},
    accordionItemHeadingUI = {},
    accordionItemHeadingButtonUI = {},
    accordionItemPanelUI = {},
    accordionDescription = {},
    accordionDescriptionTitle = {},
    accordionDetailsTitle = {},
    accordionSourceTitle = {},
    data,
    accordionSourceLink = {},
    accordionSourceLinkIcon = {},
    lastUpdatedTitle = {},
    lastUpdatedDate = {},
    lastUpdatedFormat = 'MMMM D, YYYY',
    iconDropdown = {},
    iconCategory = {},
    iconsMapperColors = {
      allowance: ['#00855C', '#FE965C', '#E70056', '#757575'],
      required: ['#00855C', '#FE965C', '#E70056', '#757575']
    },
    iconsMapper = {
      NO_RESTRICTION: 'check-circle',
      NO_ENTRY: 'block',
      ENTRY: 'block',
      RESTRICTED_ENTRY: 'block',
      NO_EXIT: 'block',
      EXIT: 'block',
      RESTRICTED_EXIT: 'block',
      BOARDING: 'block',
      TRANSIT: 'block',
      QUARANTINE: 'home',
      DOC_REQUIRED: 'note-add',
      PPE: 'mask',
      HEALTH_ASSESSMENT: 'medical-services',
      COVID_19_TEST: 'coronavirus',
      HEALTH_MEASURES: 'medical-services',
      SANITIZATION: 'sanitizer',
      DEPOSIT_REQUIRED: 'monetization',
      DEFAULT: 'note-add',
      WARNING: 'warning',
      //Smartvel defauls icons
      ENTRY_REQUIREMENTS: 'airplane-arrive',
      TRANSIT_REQUIREMENTS: 'train',
      TEST: 'coronavirus',
      FORMS: 'note-add',
      HEALTH_INSURANCE: 'medical-services'
    },
    accordionSource = {},
    lastUpdated = {},
    categoryContainer = {},
    accordionTestingTitle = {},
    testingContainerSettings = {},
    testWindowItemContainer = {},
    testWindowItemType = {},
    testWindowItem = {},
    documentLinkContainer = {},
    documentLink = {},
    documentLinkIcon = {},
    scrollIntoView = false,
    showLabelForRestriction = false,
    restrictionsDisclaimer
  } = props;

  const getIcon = (category) => {
    const defaultIcon = iconsMapper.DEFAULT || 'note-add';
    if (iconsMapper[category]) {
      return iconsMapper[category];
    }
    return defaultIcon;
  };

  const getFillColor = (typeOfIcon, typeofOption) => {
    const color = iconsMapperColors[typeofOption][typeOfIcon];
    if (color) {
      return color;
    }
  };
  const { direction, translate, theme } = useContext(Context);

  const [accordionClass] = useStyles(accordionUI, { direction, theme });
  const [AccordionItemHeadingClass] = useStyles(accordionItemHeadingUI, { direction, theme });
  const [AccordionItemHeadingButtonClass] = useStyles(accordionItemHeadingButtonUI, {
    direction,
    theme
  });

  const handleFocus = (arrayId) => {
    if (scrollIntoView && !isSSR()) {
      const id = arrayId[0];
      if (id) {
        const ele = document.querySelector(`#accordion__heading-${id}`);
        if (ele) {
          ele.scrollIntoView();
        }
      }
    }
  };

  const renderAccordion = (items) => {
    return (
      <Accordion className={accordionClass} allowZeroExpanded onChange={handleFocus}>
        {data.source === 'Sherpa' &&
          items.map(({ type, data }) => {
            return data.length !== 0 ? (
              <Box {...categoryContainer}>
                {data.length !== 0 && (
                  <Box {...categoryTitleContainerSetting}>
                    <Text {...categoryTitle}>
                      {translate(
                        `cmp-${type.replace(new RegExp('_', 'g'), '-')}`.toString().toLowerCase(),
                        `cmp-${type.replace(new RegExp('_', 'g'), '-')}`.toString().toLowerCase()
                      )}
                    </Text>
                  </Box>
                )}
                {data.map((item) => (
                  <AccordionItem activeClassName="accordion-item-active" key={item.index}>
                    <AccordionItemHeading className={AccordionItemHeadingClass}>
                      <AccordionItemButton
                        className={`AccordionItemButton ${AccordionItemHeadingButtonClass}`}
                      >
                        <Icon icon={getIcon(item.category)} viewBox="0 0 24 24" {...iconCategory} />
                        <Text {...accordionContentTitle}>
                          {item.title.includes('-') ? translate(item.title) : item.title}
                        </Text>
                        <Icon
                          className="fr-icon-dropdown"
                          icon={'keyboard_arrow_down'}
                          viewBox="0 0 1024 1024"
                          {...iconDropdown}
                        />
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <Box {...accordionItemPanelUI}>
                        <Text {...accordionDescriptionTitle}>
                          {translate('cmp-travel-restriction-description-title', 'Description')}
                        </Text>
                        <Text {...accordionDescription}>{item.description}</Text>

                        {item.more?.length > 0 && (
                          <>
                            <Text {...accordionDetailsTitle}>
                              {translate(
                                'cmp-travel-restriction-details-title',
                                'Details & Exemption'
                              )}
                            </Text>
                            <Box {...detailsAndExemptionsContainerSettings}>
                              {item.more.map((e) => (
                                <Text {...lastUpdated}>{e}</Text>
                              ))}
                            </Box>
                          </>
                        )}
                        {item.testWindow?.length > 0 && (
                          <>
                            <Text {...accordionTestingTitle}>
                              {translate('cmp-travel-restriction-testing-title', 'Testing Types')}
                            </Text>
                            <Box className="testWindows Container" {...testingContainerSettings}>
                              {item.testWindow?.map((e) => {
                                return (
                                  <Box {...testWindowItemContainer}>
                                    <Text {...testWindowItemType}>
                                      {translate(
                                        `cmp-travel-restriction-test-${e.medicalRequirementType
                                          .replace(new RegExp('_', 'g'), '-')
                                          .toString()}`,
                                        e.medicalRequirementType
                                      )}
                                    </Text>
                                    <Text {...testWindowItem}>{`${e.value} ${translate(
                                      `cmp-travel-restriction-test-type-${e.type.toLowerCase()}`,
                                      e.type.toLowerCase()
                                    )} 
                                  ${
                                    e.condition
                                      ? translate(
                                          `cmp-travel-restriction-test-condition-${e.condition
                                            .replace(new RegExp('_', 'g'), '-')
                                            .toString()
                                            .toLowerCase()}`,
                                          e.condition
                                        )
                                      : ''
                                  }
                                  `}</Text>
                                  </Box>
                                );
                              })}
                            </Box>
                          </>
                        )}
                        {item.documentLinks?.length > 0 && (
                          <Box marginBottom="10px" {...documentLinkContainer}>
                            {item.documentLinks.map((item) => (
                              <Link
                                display="inline-flex"
                                marginRight="5px"
                                {...documentLink}
                                href={item.url}
                                target="_blank"
                              >
                                {item.title}
                                <Icon
                                  marginLeft="3px"
                                  icon="openInNew"
                                  {...documentLinkIcon}
                                  ariaLabel={
                                    translate('cmp-separator-comma', ', ') +
                                    translate('cmp-travel-restriction-new-tab', 'open in new tab:')
                                  }
                                />
                              </Link>
                            ))}
                          </Box>
                        )}
                        {item.source.title && (
                          <Box {...accordionSource}>
                            <Text {...accordionSourceTitle}>
                              {translate('cmp-travel-restriction-source', 'Source:')}
                            </Text>
                            <Link
                              display="inline-flex"
                              {...accordionSourceLink}
                              href={item.source.url}
                              target="_blank"
                            >
                              {item.source.title}
                              <Icon
                                marginLeft="3px"
                                icon="openInNew"
                                {...accordionSourceLinkIcon}
                                ariaLabel={
                                  translate('cmp-separator-comma', ', ') +
                                  translate('cmp-travel-restriction-new-tab', 'open in new tab:')
                                }
                              />
                            </Link>
                          </Box>
                        )}
                        {item.lastUpdatedAt && (
                          <Box {...lastUpdated}>
                            <Text marginRight="3px" {...lastUpdatedTitle}>
                              {translate('cmp-travel-restriction-updated-on', 'Updated on')}
                            </Text>
                            <Text {...lastUpdatedDate}>
                              {dayjs(item.lastUpdatedAt).format(lastUpdatedFormat)}
                            </Text>
                          </Box>
                        )}
                      </Box>
                    </AccordionItemPanel>
                  </AccordionItem>
                ))}
              </Box>
            ) : null;
          })}
        {data.source === 'Smartvel' && (
          <>
            {items.map(({ labelKeyForText, labelKeyForData, typeOfIcon, typeofOption, icon }) => {
              return (
                <Box {...categoryContainer}>
                  <Box {...categoryTitleContainerSetting}>
                    <Icon
                      icon={getIcon(icon)}
                      viewBox="0 0 24 24"
                      fill={getFillColor(typeOfIcon, typeofOption)}
                      {...iconCategory}
                    />
                    {showLabelForRestriction && (
                      <Text {...categoryLabel}>{translate(labelKeyForText, labelKeyForText)}</Text>
                    )}
                    <Text {...categoryText}>{translate(labelKeyForData, labelKeyForData)}</Text>
                  </Box>
                </Box>
              );
            })}
            <Disclaimer
              labelKey="cmp-travel-restriction-quick-facts-disclaimer"
              {...restrictionsDisclaimer}
            />
          </>
        )}
      </Accordion>
    );
  };
  return (
    <>
      {data.arrive &&
        data.arrive.length > 0 &&
        props.activeTab === 'departure-restriction' &&
        renderAccordion(data.arrive)}
      {data.returning &&
        data.returning.length > 0 &&
        props.activeTab === 'return-restriction' &&
        renderAccordion(data.returning)}
    </>
  );
};

export default RequirementsAccordion;
